export default __webpack_public_path__ + "static/media/xp-toast.67eef0df.svg";